import { closeAllChannels } from '../../utils/closeAllChannels.js'
import { activateScreen } from '../../utils/activateScreen.js'

export const handleTabChange = (tab, singleChannel) => {
  const widgetWindow = document.querySelector('.cce-widget__window')
  const channelPicker = document.querySelector('.cce-widget__channel-picker')
  const bubble = document.querySelector('.cce-widget__bubble')
  const container = document.querySelector('.cce-widget__window__container')
  const header = document.querySelector('.cce-widget__window__header')
  const backArrow = document.querySelector('.cce-widget__window__header--back')
  const faqBackArrow = document.querySelector('[name=ccewHandleFaqChannel]')
  const footerMenu = document.querySelector('.cce-widget__window__footer__menu')

  const openTab = ({ widgetClass, channelName, bubbleModifier, headerModifier, footerModifier }) => {
    closeAllChannels()
    document.querySelector(`.cce-widget-${widgetClass}`).classList.add('open')
    channelPicker.classList.remove('cce-widget__channel-picker--open')
    container.classList.add('cce-widget__window--with-channel', `cce-widget__window--with-channel-${channelName}`)
    bubble.classList.add(`cce-widget__bubble--with-${bubbleModifier}`, 'cce-widget__bubble--with-channel')
    header.classList.add(`cce-widget__window__header-${headerModifier}`)
    const footerButton = footerMenu.querySelector(`[data-channel-type=${footerModifier}]`)
    if (footerButton) {
      footerButton.classList.add(`cce-widget__window__footer__menu__option-open`)
    }
  }

  const hideBackArrow = (faq = false) => {
    backArrow.classList.add(`cce-widget__window__header--back-hide`)
    if (faq && faqBackArrow) {
      faqBackArrow.classList.add(`cce-widget__window__header__faq--back--hide`)
    }
  }

  switch (tab) {
    case 'channel_picker':
      closeAllChannels()
      channelPicker.classList.add('cce-widget__channel-picker--open')
      bubble.classList.remove('cce-widget__bubble--with-channel')
      const footerButton = footerMenu.querySelector(`[name=mainMenu]`)
      if (footerButton) {
        footerButton.classList.add(`cce-widget__window__footer__menu__option-open`)
      }
      break

    case 'chat':
      openTab({
        widgetClass: 'chat',
        channelName: 'chat',
        bubbleModifier: 'chat',
        headerModifier: 'chat',
        footerModifier: 'chat',
      })
      if (singleChannel) {
        hideBackArrow()
      }
      break
    case 'facebookMessenger':
      openTab({
        widgetClass: 'facebookMessenger',
        channelName: 'facebookMessenger',
        bubbleModifier: 'messenger',
        headerModifier: 'messenger',
        footerModifier: 'facebook',
      })
      if (singleChannel) {
        hideBackArrow()
      }
      break

    case 'whatsapp':
      openTab({
        widgetClass: 'whatsapp',
        channelName: 'whatsapp',
        bubbleModifier: 'whatsapp',
        headerModifier: 'whatsapp',
        footerModifier: 'genesysWhatsapp',
      })
      if (singleChannel) {
        hideBackArrow()
      }
      break

    case 'audio':
      closeAllChannels()
      openTab({
        widgetClass: 'audio',
        channelName: 'audio',
        bubbleModifier: 'audio',
        headerModifier: 'audio',
        footerModifier: 'audio',
      })
      if (singleChannel) {
        hideBackArrow()
      }
      break

    case 'video':
      openTab({
        widgetClass: 'video',
        channelName: 'video',
        bubbleModifier: 'video',
        headerModifier: 'video',
        footerModifier: 'video',
      })
      if (singleChannel) {
        hideBackArrow()
      }
      break

    case 'callback':
      openTab({
        widgetClass: 'callback',
        channelName: 'callMeNow',
        bubbleModifier: 'callMeNow',
        headerModifier: 'callMeNow',
        footerModifier: 'callMeNow',
      })
      activateScreen('cce-widget-callback', 'start')
      if (singleChannel) {
        hideBackArrow()
      }
      break

    case 'scheduledVideo':
      openTab({
        widgetClass: 'scheduledVideo',
        channelName: 'scheduledVideo',
        bubbleModifier: 'scheduledVideo',
        headerModifier: 'scheduledVideo',
        footerModifier: 'scheduledVideo',
      })
      activateScreen('cce-widget-scheduledVideo', 'schedule')
      if (singleChannel) {
        hideBackArrow()
      }
      break

    case 'faq':
      openTab({
        widgetClass: 'faq',
        channelName: 'faq',
        bubbleModifier: 'faq',
        headerModifier: 'faq',
        footerModifier: 'faq',
      })
      if (singleChannel) {
        hideBackArrow(true)
      }
      break

    case null:
      closeAllChannels()
      widgetWindow.classList.remove('cce-widget__window--open')
      break
  }
}
